/**
 * © [2023] Conduent, Inc. All rights reserved. Conduent®and Conduent Agile
 * Star®are trademarks of Conduent, Inc. and/or its subsidiaries in the United
 * States and/or other countries.
 */
import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import TextField from '@material-ui/core/TextField';
import CustomSeparator from '../../../../SharedModules/Breadcrumbs/BreadcrumbsComponent';
import TableGrid from '../../../../SharedModules/Table/TableGridWithFeatures';
import { TableHead } from './tableHead';
import { viewPortHeight_355 } from '../../../../SharedModules/CommonConstants/commonConstants';
import Spinner from '../../../../SharedModules/Spinner/Spinner';

export default function DispOutstandingDisputesNumOfDays() {
  const dispatch = useDispatch();
  const [fullScreenView, setfullScreenView] = React.useState(false);

  const handleFullScreenView = () => {
    setfullScreenView(!fullScreenView);
  };

  const {
    isLoading,
    rebateProgramValue,
    rebateProgramList,
    allRebateProgram,
    numOfDays,
    searchResult,
    rebateProgrameName,
  } = useSelector(
    (state) => state?.sharedState?.OutstandingDisputesNumOfDaysReducer
  );
  // TO get the complete name of the rebate program
  const rebateProgramNameValue = rebateProgrameName;
  const thirdInfo = `${
    allRebateProgram ? 'All Rebate Programs' : `${rebateProgramNameValue}`
  }`;

  return (
    <div className="tabs-container bottom-pinned-bold">
      <Spinner load={isLoading} />
      {!fullScreenView && (
        <CustomSeparator
          parent1="State Reports"
          parent2="Display Outstanding Disputes After Num of Days"
        />
      )}

      {!fullScreenView && (
        <div className="tab-body custom-search-dates">
          <div className="mui-custom-form input-md field-xl">
            <div className="row mb-2 mt-2">
              <div className="col-6">
                <TextField
                  label="Rebate Program : "
                  id="Rebate Program"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={
                    allRebateProgram
                      ? 'ALL Rebate Programs'
                      : rebateProgramNameValue
                  }
                  name="RebateProgram"
                  disabled
                />
              </div>
              <div className="col-6">
                <TextField
                  label="Outstanding After Days : "
                  id="Outstanding After Days"
                  fullWidth
                  placeholder=""
                  InputLabelProps={{
                    shrink: true,
                  }}
                  value={numOfDays}
                  name="OutstandingAfterDays"
                  disabled
                />
              </div>
            </div>
          </div>
        </div>
      )}
      <TableGrid
        columnDefs={TableHead}
        rowData={searchResult || []}
        rowSelection="single"
        showSearchInfo
        enterMovesDown
        handleViewHistory={false}
        hideTotalCount={false}
        exportFile
        data-testid="onEditingStopped"
        defaultCol={{
          wrapHeaderText: true,
          autoHeaderHeight: true,
        }}
        fileName="OutstandingDisputesafterNDays"
        reportName="Outstanding Disputes After Num of Days Report"
        suppressCellFocus
        fullScreenView={fullScreenView}
        handleFullScreenViewClick={handleFullScreenView}
        gridHeight={fullScreenView ? '70vh' : viewPortHeight_355}
        info={{ thirdInfo }}
      />
    </div>
  );
}
